import styled from 'styled-components/macro';
import {
  space,
  layout,
  position,
  LayoutProps,
  PositionProps,
  SpaceProps,
} from 'styled-system';

interface ButtonWithIconProps {
  className?: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  altText: string;
  onClick?: () => void;
  disabled?: boolean;
}

const ButtonWithIcon = (props: ButtonWithIconProps) => {
  const { className, icon: Icon, altText, onClick, disabled } = props;

  return (
    <button
      className={className}
      onClick={onClick}
      disabled={disabled}
      aria-label={altText}
    >
      <Icon style={{ maxWidth: '100%', maxHeight: '100%' }} />
    </button>
  );
};

type IconButtonBasicProps = LayoutProps &
  PositionProps &
  SpaceProps & {
    disabled?: boolean;
    loading?: boolean;
  };

export type IconButtonProps = React.ComponentProps<typeof IconButton>;

export const IconButton = styled(ButtonWithIcon)<IconButtonBasicProps>`
  width: 20px;
  height: 20px;
  background: transparent;
  border: none;
  cursor: ${(props) => (props.disabled || props.loading ? 'not-allowed' : 'pointer')};
  transition: filter 0.2s, transform 0.2s, box-shadow 0.1s;
  ${space}
  ${layout}
  ${position}

  animation: ${(props) => (props.loading ? 'pulse1 1.5s ease-in-out infinite' : 'none')};

  > img {
    margin: 0;
  }

  :hover {
    transform: translateY(-1px);
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2));
  }

  :active {
    transform: translateY(1px);
  }

  :disabled {
    opacity: 0.35;
    cursor: default;
  }

  :disabled:hover {
    transform: none;
    filter: none;
  }

  &.focus-visible {
    outline: none;
    border-radius: 4px;
    box-shadow: 0px 0px 0px 2px ${(props) => props.theme.textColor};
  }

  @media screen and (max-width: 767px) {
    width: 25px;
    height: 25px;
    ${space}
    ${layout}
    ${position}
  }

  @keyframes pulse1 {
    0% {
      opacity: 0.3;
      transform: scale(0.9);
    }

    50% {
      opacity: 1;
      transform: scale(1);
    }

    100% {
      opacity: 0.3;
      transform: scale(0.9);
    }
  }
`;

export const CloseButton = styled(IconButton)`
  position: absolute;
  right: 12px;
  top: 12px;
`;
